/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $GraphicsBox, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {$ButtonRuby} from '../../../JSX/ButtonRuby';
import {computedFormatCents} from '../../../../../JSX/helpersFormat';
import {MainUiProps} from './UIDefault';
import {$PanelDisplay} from './PanelDisplay';
import {$BetSelect} from './BetSelect';
import {$SoundBtn} from './SoundBtn';
import {$TurboBtn} from './TurboBtn';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
// import {$WinAreaLandscape} from './WinArea/WinAreaLandscape';

export const $ControlsPanelLandscape: FC<MainUiProps> = (props) => {
    const balance = computedFormatCents(props.balance);
    const controlsPosition = Store.computed<ResponsiveConf>(() => {
        const jZoneHeight = getProp(props.jurisdictionZoneHeight);

        return {
            box: {width: '100%', height: '120px', y: '100%'},
            translate: {y: `${(jZoneHeight + 120) * -1}px`}
        };
    });

    return <$GraphicsBox
        name='controls_panel_portrait'
        responsive={controlsPosition}
        responsiveBoxSize
        boxColor={0x000}
        boxAlpha={0.32}
        visible={slotStore.stage_isLandscape}
        {...props}
    >
        <$SoundBtn
            responsive={{box: {y: '50%', x: `${12*3+108/2}px`}}}
            action={props.onSoundBtn}
            soundEnabled={props.soundEnabled}
        />
        <$ButtonRuby
            icon='btn_icon_menu'
            bg='round_btn_bg'
            responsive={{box: {y: '50%', x: `${(12*3)+8*3+108*1.5}px`}}}
            action={props.onMenuBtn}
            hitArea='round'
        />
        <$BetSelect
            label='cashLabel'
            betFormatted={props.betFormatted}
            betCurrent={props.betCurrent}
            betList={props.betList}
            action={props.onBetChangeBtn}
            responsive={{
                box: {y: '50%', x: '100%'},
                translate: {x: '-290px'},
            }}
        />
        <$PanelDisplay
            label='cashLabel'
            value={balance}
            maxWidth={90*3}
            responsive={{
                box: {y: '50%', x: '484px'},
            }}
        />
        <$TurboBtn
            responsive={{
                box: {x: '100%', y: '-100px'},
                translate: {x: '-166px'},
            }}
            currentLevel={props.turboLevel}
            action={props.onTurboBtn}
        />
        {/* <$WinAreaLandscape/> */}
    </$GraphicsBox>;
};